@if (isLoading) {
  <div tabindex="0" autofocus style="outline: none" class="row hup-subscription-detail" xmlns="http://www.w3.org/1999/html">
    <div class="col-12 offset-lg-2 col-lg-8 hup-subscription-detail__loading">
      <div class="text-center hup-subscription-detail__spinner">
        <app-loading-spinner/>
      </div>
    </div>
  </div>
}

@if (!isLoading && sub) {
  <div class="row">
    <div class="col-12 offset-lg-2 col-lg-8">
      <div class="hup-subscription-detail__content">
        <div class="hup-subscription-detail__header">
          <h3 *appApplyIfNotEmpty="translationService.getTranslation('subscription_header')"
              [innerHTML]="translationService.getTranslation('subscription_header')"
              class="hup-subscription-detail__title"></h3>
        </div>
        <div class="hup-subscription-detail__intro">
          <p [innerHTML]="translationService.getTranslation('subscription_intro')"
              class="hup-subscription-detail__subtitle"></p>
        </div>
        @if (sub.state === 3) {
          <div class="hup-subscription-detail__canceled"
               [innerHTML]="translationService.getTranslation('subscription_canceled')">
          </div>
        }
        <mat-card class="mt-4 mat-mdc-card-outlined hup-subscription-detail__card">
          <mat-card-content class="hup-subscription-detail__card-content">
                <div class="form-group hup-subscription-detail__user">
                  <div class="hup-subscription-detail__user-row">
                    @if (sub.userBackendId >= 0) {
                      <div class="hup-subscription-detail__user-backendid"
                           [innerHTML]="translationService.getTranslation('label_backendid') + ': ' + sub.userBackendId">
                      </div>
                    }
                    @if (sub.userBackendId < 0) {
                      <div class="hup-subscription-detail__user-backendid"
                           [innerHTML]="translationService.getTranslation('label_backendid') + ': ' + translationService.getTranslation('subscription_user_not_assigned')">
                      </div>
                    }
                  </div>
                </div>
              <div class="form-group hup-subscription-detail__email">
                <div class="hup-subscription-detail__email-row">
                  @if (userData && userData.emailList?.length > 0) {
                    <div class="hup-subscription-detail__email-value"
                         [innerHTML]="translationService.getTranslation('label_email') + ': ' + userData.emailList[0]"></div>
                  }
                </div>
              </div>

              <h5 class="mt-5 hup-subscription-detail__details-title"
                  *appApplyIfNotEmpty="translationService.getTranslation('label_subscriptionDetails')"
                  [innerHTML]="translationService.getTranslation('label_subscriptionDetails')"></h5>

              <div class="form-group hup-subscription-detail__order">
                <div class="hup-subscription-detail__order-row">
                  @if (sub.backendId > 0) {
                    <div class="hup-subscription-detail__order-id"
                         [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.backendId">
                    </div>
                  }
                  @if (sub.backendId <= 0) {
                    <div class="hup-subscription-detail__order-id"
                         [innerHTML]="translationService.getTranslation('order_id') + ': ' + translationService.getTranslation('no_order_id')">
                    </div>
                  }
                </div>
              </div>

              @if (showAdditionalSubscriptionInfos) {
                @for (key of blockOrder; track key) {
                  @switch (key) {
                    @case ('PAYMENT') {
                      @if (sub.curPayment) {
                        <h5 class="d-inline-block mt-4" [innerHTML]="translationService.getTranslation('navi_bankchange')"></h5>&nbsp;

                        @let onlinePayment = isOnlinePayment(sub);
                        @if (!onlinePayment) {
                        <a [routerLink]="'/payment'"
                           [attr.aria-label]="translationService.getTranslation('navi_bankchange') + ' ' + translationService.getTranslation('button_edit')">
                           <mat-icon fontIcon="edit"/>
                         </a>
                        }

                        <div class="form-group hup-subscription-detail__payment">
                          <div class="hup-subscription-detail__payment-row">
                            <div class="hup-subscription-detail__payment-info">
                              <div class="hup-subscription-detail__payment-method">
                                {{ paymentMethodDesc }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group hup-subscription-detail__payment">
                          <div class="hup-subscription-detail__payment-row">
                            <div class="hup-subscription-detail__payment-info">
                              <div class="hup-subscription-detail__payment-frequency">
                                {{ sub.curPayment.paymentType.paymentFrequency }}
                              </div>
                            </div>
                          </div>
                        </div>
                        @if (paymentMethodId && paymentMethodId.paymentType === 'DIRECTDEBITIBAN') {
                          <div class="form-group hup-subscription-detail__payment">
                            <div class="hup-subscription-detail__payment-row">
                              <div class="hup-subscription-detail__payment-info">
                                <div class="hup-subscription-detail__payment-iban"
                                  [innerHTML]="translationService.getTranslation('payment_iban') + ': ' + sub?.curPayment?.bank?.swiftIBAN | bankAccount">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group hup-subscription-detail__payment">
                            <div class="hup-subscription-detail__payment-row">
                              <div class="hup-subscription-detail__payment-info">
                                <div class="hup-subscription-detail__payment-bic"
                                  [innerHTML]="translationService.getTranslation('payment_bic') + ': ' + sub?.curPayment?.bank?.swiftBIC">
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      }
                    }
                    @case ('CONTRACT_CURRENT') {
                      @if (!currentAndSequelSubscriptionsAreSimilar()) {
                        <div class="hup-subscription-detail__combi">
                          @if (sub.combiSubscriptionList && sub.combiSubscriptionList.length > 0) {
                            <h5 class="mt-4 hup-subscription-detail__combi-title"
                                *appApplyIfNotEmpty="translationService.getTranslation('subscription_aggregate_combinations')"
                                [innerHTML]="translationService.getTranslation('subscription_aggregate_combinations')"></h5>
                          }
                          <app-product-variant-period-block [subscription]="sub"
                                                            class="hup-subscription-detail__combi-block"></app-product-variant-period-block>
                          @for (comb of sub.combiSubscriptionList; track comb) {
                            <div class="hup-subscription-detail__combi-item">
                              <app-product-variant-period-block [subscription]="comb"
                                                                class="hup-subscription-detail__combi-block"></app-product-variant-period-block>
                            </div>
                          }
                        </div>
                      }
                    }
                    @case ('CONTRACT_FUTURE') {
                      @if (sub.sequelSubscriptions && sub.sequelSubscriptions.length > 0 && showSequelSubscriptionInAggregateMode) {
                        @if (sub.sequelSubscriptions && sub.sequelSubscriptions.length > 0) {
                          <h5 class="mt-4 hup-subscription-detail__sequel-title"
                              *appApplyIfNotEmpty="translationService.getTranslation('subscription_aggregate_sequels')"
                              [innerHTML]="translationService.getTranslation('subscription_aggregate_sequels')"></h5>
                        }
                        @for (sequel of sub.sequelSubscriptions; track sequel) {
                          <app-product-variant-period-block [subscription]="sequel"
                                                            class="hup-subscription-detail__sequel-block"></app-product-variant-period-block>
                          @for (sequelComb of sequel.combiSubscriptionList; track sequelComb) {
                            <div class="hup-subscription-detail__sequel-combi-item">
                              <app-product-variant-period-block [subscription]="sequelComb"
                                                                class="hup-subscription-detail__sequel-combi-block"></app-product-variant-period-block>
                            </div>
                          }
                        }
                      }
                    }
                    @case ('ADR_DELIVERY') {
                      @if (sub.curDelivery) {
                        <h5 class="d-inline-block mt-4 hup-subscription-detail__delivery-title"
                            *appApplyIfNotEmpty="translationService.getTranslation('address_delivery')"
                            [innerHTML]="translationService.getTranslation('address_delivery')"></h5>&nbsp;
                        @if (isMoveServiceActive()) {
                          <a [routerLink]="'/move'"
                             [attr.aria-label]="translationService.getTranslation('navi_bankchange') + ' ' + translationService.getTranslation('button_edit')"
                          ><mat-icon fontIcon="edit"/></a>
                        }
                        <div class="form-group hup-subscription-detail__delivery">
                          <app-address-detail [address]="sub.curDelivery.address"
                                              [person]="sub.curDelivery.person"
                                              class="hup-subscription-detail__delivery-detail"></app-address-detail>
                        </div>
                      }
                    }
                    @case ('ADR_BILLING') {
                      @if (sub.curBilling) {
                        <h5 class="mt-4 hup-subscription-detail__billing-title"
                            [innerHTML]="translationService.getTranslation('address_billing')"></h5>
                        <div class="form-group hup-subscription-detail__billing">
                          <app-address-detail [address]="sub.curBilling.address"
                                              [person]="sub.curBilling.person"
                                              class="hup-subscription-detail__billing-detail"></app-address-detail>
                        </div>
                      }
                    }
                  }
                }
              }

              @if (sub.subId > 0 && showTerminationButton) {
                <div class="form-group mt-5 hup-subscription-detail__termination">
                  <div class="hup-subscription-detail__termination-row">
                    <div class="hup-subscription-detail__termination-action">
                      @if (isTerminatable(sub)) {
                        <button mat-raised-button
                                (click)="terminateSubscription()"
                                [innerHTML]="translationService.getTranslation('button_terminate')"
                                [disabled]="navigationToExternalOrderImpossible"
                                class="hup-subscription-detail__termination-btn">
                        </button>
                      } @else {
                        @if (sub.subId > 0 && sub.webId > 0) {
                          <div
                            class="hup-subscription-detail__terminated hup-subscription-detail__terminated--webabo">{{ translationService.getTranslation('subscription_terminated_webabo') }}
                          </div>
                        }
                        @if (sub.subId > 0 && sub.webId < 0) {
                          <div
                            class="hup-subscription-detail__terminated hup-subscription-detail__terminated--paradise">{{ translationService.getTranslation('subscription_terminated_paradise') }}
                          </div>
                        }
                      }
                    </div>
                    <div class="col-12 col-sm-6">
                    </div>
                  </div>
                </div>
              }
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}

@if (showBackToOverviewButton) {
  <div class="row mt-3 hup-subscription-detail__back">
    <div class="col-12 offset-lg-2 col-lg-8 text-end">
      <button
        mat-raised-button (click)="backToOverview()"
        [innerHTML]="translationService.getTranslation('button_back_to_overview')"
        class="hup-subscription-detail__back-btn"></button>
    </div>
  </div>
}
